import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    fallbackLng: 'en',
    ns: ['default'],
    defaultNS: 'default',
  })
}

export default i18n
